import { Divider, Stack } from "@mui/material";
import { CardBlock } from "../CardBlock";
import { StartGenerateAccountPlanBtn } from "../../../ui/buttons/StartGenerateAccountPlanBtn";
import { useGetCampaignDetailsQuery } from "../../../../api";
import { Link, useParams } from "react-router-dom";
import { useAppSelector, useNotFoundRedirect } from "../../../../hooks";
import { RemoveAccountPlanBtn } from "../../../ui/buttons";
import { GradientButton } from "components/ui";
import { AppRoutes } from "../../../../types/enums";

export const AccountPlanReports = () => {
  const { account_id, campaign_id } = useParams();
  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  const { data, error } = useGetCampaignDetailsQuery(
    { account_id: account_id! },
    { skip: !account_id, refetchOnMountOrArgChange: true },
  );

  useNotFoundRedirect({ error });

  return (
    <Stack gap={"24px"} flexGrow={1}>
      {!data?.has_committee_changes ? (
        <CardBlock
          title={"Contacts Updated — Your Account Plan Might Need an Update"}
          texts={[
            "You’ve recently made changes to the contacts in this account. Update your" +
              " plan to keep role distribution, engagement priorities, and outreach strategies aligned and up to date.",
          ]}
          btn={
            <StartGenerateAccountPlanBtn
              account_id={account_id!}
              campaign_id={campaign_id!}
              account={data!}
            />
          }
        />
      ) : (
        <CardBlock
          borderColor={"none"}
          bgColor={"#F7F7F7"}
          title={`Get a Tailored Account Overview for ${data?.output?.company?.name!}`}
          texts={[
            "Discover company profile, growth strategy, relevant industry insights, key stakeholders analysis, and" +
              " detailed engagement plan with conversation guidelines to boost your sales.",
          ]}
          btn={
            <Link to={`/${campaign_id}${AppRoutes.ACCOUNT_PLAN}/${account_id}`}>
              <GradientButton>Check Account Plan</GradientButton>
            </Link>
          }
        />
      )}

      {isEditor && (
        <Stack gap={"8px"}>
          <Divider />
          <CardBlock
            borderColor={"transparent"}
            bgColor={"transparent"}
            title={"Remove Account Plan"}
            texts={[
              "Removing the Account Plan will delete all associated insights, strategy recommendations," +
                " and engagement guidelines for this account. This action cannot be undone.",
            ]}
            btn={
              <RemoveAccountPlanBtn
                companyName={data?.output?.company?.name!}
                account_id={account_id!}
                campaign_id={campaign_id!}
              />
            }
          />
        </Stack>
      )}
    </Stack>
  );
};
